import React from 'react';
import { cn } from '../../lib/utils';

export function SectionLabel({ children, className }) {
  return (
    <span className={cn(
      "inline-block text-xs font-mono uppercase tracking-[0.2em] text-[#2E79FF] mb-4",
      className
    )}>
      {children}
    </span>
  );
}

export function SectionTitle({ children, className }) {
  return (
    <h2 className={cn(
      "text-2xl sm:text-3xl lg:text-4xl font-medium tracking-tight text-white",
      className
    )}>
      {children}
    </h2>
  );
}

export function SectionSubtitle({ children, className }) {
  return (
    <p className={cn(
      "text-base sm:text-lg text-[#A1A1AA] mt-4 max-w-2xl",
      className
    )}>
      {children}
    </p>
  );
}

export function Section({ id, className, children, dark = false }) {
  return (
    <section 
      id={id}
      className={cn(
        "py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8",
        dark && "bg-[#0F1014]/50",
        className
      )}
    >
      <div className="max-w-6xl mx-auto">
        {children}
      </div>
    </section>
  );
}

export function SectionHeader({ label, title, subtitle, centered = true, className }) {
  return (
    <div className={cn(
      "mb-12 lg:mb-16",
      centered && "text-center",
      className
    )}>
      {label && <SectionLabel>{label}</SectionLabel>}
      <SectionTitle>{title}</SectionTitle>
      {subtitle && (
        <SectionSubtitle className={centered ? "mx-auto" : ""}>
          {subtitle}
        </SectionSubtitle>
      )}
    </div>
  );
}
